import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Div, Icon, Text } from '@pinpoint/design-kit';

function ButtonCard({
  w,
  h,
  m,
  topBg,
  hoverTopBg,
  cardProps,
  iconName,
  iconSize,
  iconViewBox,
  iconProps,
  nameProps,
  name,
  bottomBg,
  hoverBottomBg,
  description,
  disabled,
  onClick,
}) {
  const [hovered, setHovered] = useState(false);
  return (
    <Button
      w={w}
      h={h}
      bg={hovered ? hoverTopBg : topBg}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      d="flex"
      m={m}
      p="0"
      flexDir="column"
      rounded="0"
      shadow="6"
      style={{
        borderRadius: '8px',
      }}
      onMouseOver={() => {
        if (!disabled) {
          setHovered(true);
        }
      }}
      onMouseLeave={() => {
        if (!disabled) {
          setHovered(false);
        }
      }}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      {...cardProps}
    >
      <Div h="65%" w="100%" d="flex">
        <Div p={{ l: '41px', t: '39px' }}>
          <Icon
            name={iconName}
            size={iconSize}
            color={disabled ? 'lightGrey' : hovered ? topBg : bottomBg}
            viewBox={iconViewBox}
            {...iconProps}
          />
        </Div>
        <Text
          p={{ l: '25px', t: '44px', r: '50px' }}
          textWeight="600"
          textColor={disabled ? 'lightGrey' : hovered ? topBg : bottomBg}
          textAlign="left"
          style={{
            fontSize: '23px',
            lineHeight: '27px',
          }}
          {...nameProps}
        >
          {name}
        </Text>
      </Div>
      <Div
        h="35%"
        w="100%"
        p={{ l: '41px', r: '30px' }}
        bg={disabled ? 'lightGrey' : hovered ? hoverBottomBg : bottomBg}
        d="flex"
        align="center"
        justify="space-between"
        rounded="0"
        style={{
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
        }}
      >
        <Text
          textWeight="400"
          textColor={topBg}
          textAlign="left"
          style={{
            fontSize: '16px',
            lineHeight: '19px',
          }}
        >
          {description}
        </Text>
        <Icon name="LongRight" color={topBg} />
      </Div>
    </Button>
  );
}

ButtonCard.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  m: PropTypes.string,
  topBg: PropTypes.string,
  hoverTopBg: PropTypes.string,
  cardProps: PropTypes.shape({}),
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  iconViewBox: PropTypes.string,
  iconProps: PropTypes.shape({}),
  name: PropTypes.string,
  nameProps: PropTypes.shape({}),
  bottomBg: PropTypes.string,
  hoverBottomBg: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

ButtonCard.defaultProps = {
  w: '299px',
  h: '206px',
  m: '1rem',
  topBg: 'white',
  hoverTopBg: 'teal',
  cardProps: {},
  iconName: 'Positive',
  iconSize: '4rem',
  iconViewBox: '0 0 48 48',
  iconProps: {},
  bottomBg: 'teal',
  hoverBottomBg: 'tealDark2',
  name: 'Name',
  nameProps: {},
  description: 'Description',
  disabled: false,
  onClick: () => null,
};

export default ButtonCard;
